document.addEventListener('DOMContentLoaded', function() {
    // Retrieve the product identifier from the <h1> element
    var titleElement = document.querySelector('h1');
    var productHandle = titleElement ? titleElement.textContent.trim() : '';

    // Function to get a random number
    function getRandomNumber() {
        return Math.floor(Math.random() * (33 - 13 + 1)) + 13;
    }

    // Function to check if a random number is already stored for this product
    function getStoredNumber() {
        var storageKey = 'product_' + encodeURIComponent(productHandle) + '_random_number';
        var storedData = localStorage.getItem(storageKey);
        if (storedData) {
            var data = JSON.parse(storedData);
            var now = new Date().getTime();
            // Check if the stored data is still valid
            if (now - data.timestamp < 3600000) { // 1 hour
                return data.number;
            }
        }
        return null;
    }

    // Function to store a new random number
    function storeRandomNumber(number) {
        var storageKey = 'product_' + encodeURIComponent(productHandle) + '_random_number';
        var data = {
            number: number,
            timestamp: new Date().getTime()
        };
        localStorage.setItem(storageKey, JSON.stringify(data));
    }

    // Get or generate a random number
    var randomNumber = getStoredNumber();
    if (randomNumber === null) {
        randomNumber = getRandomNumber();
        storeRandomNumber(randomNumber);
    }

    // Display the number on the page
    var displayElement = document.getElementById('random-buyer-count');
    if (displayElement) {
        displayElement.innerText = randomNumber + " new orders in the last hour!";
    }
});